
/**
 *schema
 *
 * @param locations
 */
export const schemaBuild = (locations: string[]): string => {
  return locations.join(' ');
};

